import { ROUTE_LOGIN } from "../../constants/routes";
import { memoryHistory } from "../../index";
import Client from "../../libs/Api/Client";
import { goToMessenger } from "../../libs/services";
import { UserLoginResponse } from "../../proto/UserLogin_pb";
import store from "../../store";
import { setConnectionStatus } from "../../store/connection/actions";
import { ConnectionStatusType } from "../../store/connection/types";
import BaseHandler from "../BaseHandler";
import { protoHandler } from "../../libs/proto";
import { CLIENT_GET_ROOM_LIST } from "../../constants/methods";
import { PAGINATION_ROOM_LIST } from "../../constants/pagination";
import { updateRoomStatus } from "../../store/rooms/actions";

export default class HandleUserLoginResponse extends BaseHandler<UserLoginResponse> {
  handle() {
    console.log("HandleUserLoginResponse");
    const userLoginResponse = this.response.toObject();

    Client.token = userLoginResponse.accessToken;
    Client.instance.loggedIn = true;
    store.dispatch(setConnectionStatus(ConnectionStatusType.LOGGED_IN));

    if (memoryHistory.location.pathname.startsWith(ROUTE_LOGIN)) {
      // goToMessenger();
    }

    store.dispatch(updateRoomStatus("pending"));
    protoHandler(
      CLIENT_GET_ROOM_LIST,
      {
        pagination: {
          offset: 0,
          limit: PAGINATION_ROOM_LIST,
        },
      },
      { timeout: 10000 }
    ).then((res) => {
      console.log("CLIENT_GET_ROOM_LIST");
    });
  }
}
